'use client';
import { jsx } from 'react/jsx-runtime';
import { Li } from '../list/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

let s = {}, m = Object.keys(s);
const AnchorBarListItem = renderWithRef('AnchorBarListItem', s, (t, s)=>{
    let c = new Set([
        'swan-anchor-bar-list-item'
    ]), { children: n } = t;
    return jsx(RenderComp, {
        root: Li,
        forwardedRef: s,
        propKeysToRemove: m,
        classNames: c,
        props: t,
        children: n
    });
});

export { AnchorBarListItem };
